import type { MediaImage } from '@efdigital/ll-addon-data';
import { PageWidgetType } from '@efdigital/ll-addon-data';
import { DataTypeContent } from '@efdigital/ll-addon-data/data-types';
import type {
  PageWidgetImage,
  PageWidgetImageLike,
} from '@efdigital/ll-addon-data/types/content/objects/page-widget-image';
import { uniqueId } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import ImagePicker from '../../pickers/image-picker.gts';
import type {
  PageWidgetComponentSignature,
  WidgetEditor,
} from '../page-widget-signature.ts';

export class PageWidgetImageComponent extends Component<PageWidgetComponentSignature> {
  get widget() {
    return this.args.widget as PageWidgetImage;
  }

  setImage = (image: string, mediaImage?: MediaImage) => {
    this.widget.image = image;
    if (mediaImage) {
      if (mediaImage.alt) {
        this.widget.alt = mediaImage.alt;
      }
      if (mediaImage.title) {
        this.widget.title = mediaImage.title;
      }
    }
  };

  setAlt = (event: Event) => {
    const alt = (event.target as HTMLInputElement).value;
    this.widget.alt = alt;
  };

  setShowTitle = (event: Event) => {
    const showTitle = (event.target as HTMLInputElement).checked;
    this.widget.showTitle = showTitle;
  };

  <template>
    {{#let (uniqueId) as |uniqueId|}}
      <div class="card-body">
        <div class="form-group mb-4">
          <label for="{{uniqueId}}-image">Image</label>
          <ImagePicker
            @value={{this.widget.image}}
            @onChange={{this.setImage}}
            @sizeHint="original"
          />
        </div>
        <div class="form-group mb-4">
          <label for="{{uniqueId}}-alt">Alt text</label>
          <input
            class="form-control"
            id="{{uniqueId}}-alt"
            type="text"
            value={{this.widget.alt}}
            {{on "change" this.setAlt}}
          />
        </div>
        <div class="form-check mb-4">
          <input
            class="form-check-input"
            id="{{uniqueId}}-showTitle"
            type="checkbox"
            checked={{this.widget.showTitle}}
            {{on "change" this.setShowTitle}}
          />
          <label class="form-check-label" for="{{uniqueId}}-showTitle">Show
            caption</label>
        </div>
      </div>
    {{/let}}
  </template>
}

const DEFAULT_WIDGET_IMAGE: Omit<PageWidgetImageLike, 'wid'> = {
  widgetType: PageWidgetType.Image,
  title: 'Image',
  css: '',
  image: '',
  alt: '',
  showTitle: true,
};

export const ImageWidgetEditor: WidgetEditor = {
  icon: 'ph:image-bold',
  label: 'Image',
  component: PageWidgetImageComponent,
  dataType: DataTypeContent.PageWidgetImage,
  widgetData: DEFAULT_WIDGET_IMAGE,
};
